export function QuickActions() {
  return (
    <div id={"kuni-quick"} class={"kuni-quick"} hidden>
      <button type={"button"} class={"kuni-quick-scrim"} id={"kuni-quick-scrim"} tabIndex={"-1"} aria-hidden={"true"}></button>
      <div class={"kuni-quick-cluster"} id={"kuni-quick-cluster"}>
        <div class={"kuni-quick-sats"}>
          <button class={"kuni-quick-sat kuni-quick-tg"} id={"telegram-shortcut"} type={"button"} data-ui-text-title={"shell.telegram"} data-ui-text-aria={"shell.telegram"}>
            <svg class={"telegram-logo"} viewBox={"0 0 24 24"} aria-hidden={"true"}>
              <path d={"M21.6 3.1 18.5 20c-.2 1.2-.9 1.5-1.8.9l-4.8-3.5-2.3 2.2c-.3.3-.5.5-1 .5l.4-4.9 8.9-8.1c.4-.3-.1-.5-.6-.2l-11 6.9-4.7-1.5c-1-.3-1-1 .2-1.5L20.2 3c.9-.3 1.7.2 1.4.1Z"}></path>
            </svg>
          </button>
          <button class={"kuni-quick-sat kuni-quick-help"} id={"help-onboarding-button"} type={"button"} title={"Подсказки kUni"} aria-label={"Пройти знакомство с kUni ещё раз"}>
            <svg viewBox={"0 0 24 24"} aria-hidden={"true"}>
              <circle cx={"12"} cy={"12"} r={"9"}></circle>
              <path d={"M9.2 9.2a2.8 2.8 0 1 1 3.6 3.1c-.7.3-1.3.8-1.3 1.7v.4"}></path>
              <circle cx={"12"} cy={"17.2"} r={".9"} fill={"currentColor"} stroke={"none"}></circle>
            </svg>
          </button>
        </div>
        <button class={"kuni-quick-main"} id={"global-search-button"} type={"button"} aria-expanded={"false"} aria-label={"Меню"} title={"Меню"}>
          <span class={"kuni-quick-dots"} aria-hidden={"true"}>
            <i></i>
            <i></i>
            <i></i>
          </span>
          <span class={"kuni-quick-search-ico"} aria-hidden={"true"}>
            <svg viewBox={"0 0 24 24"}>
              <circle cx={"11"} cy={"11"} r={"6.5"}></circle>
              <path d={"m16 16 4.2 4.2"}></path>
            </svg>
          </span>
          <span class={"sg-search-bar-label"}>
            {"Найти…"}
          </span>
        </button>
      </div>
    </div>
  );
}
